import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, Heart, Rocket, Star, Zap, Coffee, Palette, Wand2 } from "lucide-react";

const messages = [
  { text: "Hang in there, creating beautiful moments for you...", icon: Heart },
  { text: "Almost there! Polishing the pixels...", icon: Sparkles },
  { text: "Adding that extra sparkle...", icon: Star },
  { text: "Great things take time! Almost done...", icon: Rocket },
  { text: "Brewing creativity just for you...", icon: Coffee },
  { text: "The AI is in deep thought...", icon: Wand2 },
  { text: "Crafting something amazing...", icon: Palette },
  { text: "Putting the finishing touches...", icon: Zap },
  { text: "Your content is almost ready to shine!", icon: Star },
  { text: "Magic in progress... 99% done!", icon: Sparkles },
];

export default function ProgressMessages({ progress, isVisible = true }) {
  const [currentMessage, setCurrentMessage] = useState(0);

  useEffect(() => {
    if (progress >= 90 && progress < 100) {
      const interval = setInterval(() => {
        setCurrentMessage(prev => (prev + 1) % messages.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [progress]);

  // Only show when progress is >= 90 and < 100
  if (!isVisible || progress < 90 || progress >= 100) return null;

  const message = messages[currentMessage];
  const MessageIcon = message.icon;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={currentMessage}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.3 }}
        className="flex items-center justify-center gap-2 mt-4 text-viraly-muted"
      >
        <MessageIcon className="w-4 h-4 text-viraly-orange animate-pulse" />
        <span className="text-sm">{message.text}</span>
      </motion.div>
    </AnimatePresence>
  );
}
